import React from 'react';
import { Row, Col } from 'antd';
import { ExpandNavibox, HalfPage, Rectangle, SkyscraperMobile, Wideboard } from 'components/Ads';
import { useRouter } from 'next/router';
import Content from 'layout/Basic/Content';
import Sider from 'layout/Basic/Sider';
import { SectionTitle } from 'components/Section';
import Subscription from 'containers/Subscription';
import Pagination from 'components/Pagination';
import Section from 'components/Section';
import Item from 'components/List/ArticleItem';
import GalleryBlock from 'components/GalleryBlock';
import VideoBlock from 'components/VideoBlock';
import WhitePaperBlock from 'components/WhitePaperBlock';
import { EventsSection } from 'components/EventsSection';

export interface Props {
    articles: {
        items: Article[];
        results: number;
        currentPage: number;
        numberOfPages: number;
        next: boolean;
        prev: boolean;
        paginate: boolean;
    };
    tag: Tag;
    singleGallery: Gallery;
    singleVideo: Video;
    latestIssue: Issue;
    events: Occurrence[];
    eventsPatronate: Occurrence[];
    whitePaper: WhitePaper;
    ads: PageAds;
}

export const TagPage = ({
    articles,
    tag,
    singleGallery,
    singleVideo,
    latestIssue,
    events = [],
    eventsPatronate = [],
    whitePaper,
    ads
}: Props): JSX.Element => {
    const router = useRouter();
    const { items, currentPage, results, next, prev } = articles || {
        items: [],
        currentPage: 1,
        results: 0,
        next: false,
        prev: false
    };

    const onChange = (page) => {
        router.push(`/tagi/${tag.seoSlug}?page=${page}`);
    };

    const { rectangle, skyscraper, halfpage, navibox, wideboardBottom } = ads;
    return (
        <>
            <Row gutter={16}>
                <Content>
                    <Row align="bottom">
                        <Col xs={24} md={24}>
                            <SectionTitle title={`Najnowsze z ${tag.name}`} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        {items.map((item: Article, i: number) => {
                            if (i === 3) {
                                return (
                                    <Col span={24} key={item.seoSlug}>
                                        <Item $article={item} />
                                        <Row justify="center">
                                            <Col xs={24} sm={12} xl={0}>
                                                <SkyscraperMobile
                                                    id={skyscraper[0]}
                                                    margin="12px auto 12px auto"
                                                />
                                            </Col>
                                            <Col xs={24} sm={12} xl={0}>
                                                <SkyscraperMobile
                                                    id={skyscraper[1]}
                                                    margin="12px auto 0 auto"
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                );
                            }
                            if (i === 7) {
                                return (
                                    <Col span={24} key={item.seoSlug}>
                                        <Item $article={item} />
                                        <ExpandNavibox id={navibox[0]} margin="25px auto" />
                                    </Col>
                                );
                            }
                            if (i === 13) {
                                return (
                                    <Col span={24} key={item.seoSlug}>
                                        <Item $article={item} />
                                        <ExpandNavibox id={navibox[1]} margin="25px auto" />
                                    </Col>
                                );
                            }

                            return (
                                <Col span={24} key={item.seoSlug}>
                                    <Item $article={item} />
                                </Col>
                            );
                        })}
                    </Row>
                    <Section justify="center">
                        <Col span={24}>
                            <Pagination
                                currentPage={currentPage}
                                results={results}
                                onChange={onChange}
                                next={next}
                                prev={prev}
                            />
                        </Col>
                    </Section>
                </Content>
                <Sider>
                    <Row>
                        <Col span={24}>
                            <Rectangle id={rectangle[0]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <HalfPage id={halfpage[0]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[1]} margin="16px auto" />
                        </Col>
                        {singleGallery && (
                            <Col span={24}>
                                <GalleryBlock gallery={singleGallery} />
                            </Col>
                        )}
                        <Col span={24}>
                            <Rectangle id={rectangle[2]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[3]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <HalfPage id={halfpage[1]} margin="16px auto" />
                        </Col>
                        {singleVideo && (
                            <Col span={24}>
                                <VideoBlock video={singleVideo} />
                            </Col>
                        )}
                        <Col span={24}>
                            <Rectangle id={rectangle[4]} margin="16px auto" />
                        </Col>
                        {whitePaper && (
                            <Col span={24}>
                                <WhitePaperBlock whitePaper={whitePaper} />
                            </Col>
                        )}
                        <Col span={24}>
                            <HalfPage id={halfpage[2]} margin="16px auto" />
                        </Col>
                    </Row>
                </Sider>
            </Row>
            <Section gutter={[16, 16]}>
                <Col span={24}>
                    <EventsSection events={events} eventsPatronate={eventsPatronate} />
                </Col>
            </Section>
            <Row gutter={16}>
                <Content>
                    <ExpandNavibox id={navibox[2]} margin="35px auto 0 auto" />
                </Content>
                <Sider>
                    <Rectangle id={rectangle[5]} />
                </Sider>
            </Row>
            {latestIssue && (
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Subscription issue={latestIssue} />
                    </Col>
                </Row>
            )}
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Wideboard id={wideboardBottom[0]} />
                </Col>
            </Row>
        </>
    );
};

export default TagPage;
